// lib_shim.js — standalone shim to fix the "housing issue" with esbundler.
// Reason: placing the global-exposing code in the same module as other app code can fail because esbundler
// may wrap, reorder, or tree-shake modules so the `window` assignment runs too late (or gets removed).
// Keeping this in a dedicated file guarantees it's loaded as the jQuery module replacement and
// reliably attaches jQuery to window before legacy scripts run.

import jQuery from '../js_src/js/external/jquery.min.js';
window.jQuery = window.$ = jQuery;
